module.exports = __webpack_public_path__ + "static/media/yellowFish.5191d725.svg";